import { noop } from 'lodash/fp';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { change } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { commanderForm, validation } from '@mews-commander/legacy-form';
import { getLanguageOptions } from '@mews-commander/legacy-entities/src/ducks/languages';
import { sendEmail } from '../actions';
import {
    showCustomEmail,
    getInitialValues,
    getReceiverOptions,
    getMailTypeOptions,
    getDefaultReceiverForMailType,
} from '../selectors';
import EmailSendForm, { constraints } from './EmailSendForm';

export default compose(
    connect(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            showCustomEmail,
            initialValues: getInitialValues,
            languageOptions: getLanguageOptions,
            receiverOptions: getReceiverOptions,
            mailTypeOptions: getMailTypeOptions,
        }),
        // @ts-expect-error $TSFixMeError: Property 'form' does not exist on type '{}'.
        (dispatch, { form, reservationIds, onSuccess = noop }) => ({
            onSubmit: (values: $TSFixMe) =>
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { container }: $TSFixMe) => any' is not assignable to paramet...
                (dispatch(sendEmail({ reservationIds, ...values })) as $TSFixMe).then(() => onSuccess()),
            onMailTypeOptionChange: (value: $TSFixMe) =>
                // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
                dispatch(change(form, 'receiver', getDefaultReceiverForMailType(value))),
            onReceiverOptionChange: () => dispatch(change(form, 'customEmail', null)),
        })
    ),
    commanderForm({
        enableReinitialize: true,
        validate: validation(constraints),
        submitLabel: <LocalizedText textKey={TextKey.Send} />,
    })
)(EmailSendForm);
